__webpack_require__.p = "https://app.webjoint.com/premiumshop/";